import axios from 'axios';
import { toast } from 'react-toastify';
import authHeader from '../services/authHeader';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Deletes a file from the server using the provided file path.
 * @param {string} filePath - The path of the file to delete.
 * @returns {Promise<string>} - A success message upon deletion.
 */
const fileDelete = async (filePath) => {
  if (!filePath) {
    toast.error('কোনো ফাইল পাথ প্রদান করা হয়নি।', { position: 'top-right' });
    throw new Error('File path not provided.');
  }

  try {
    const response = await axios.delete(`${API_URL}/delete`, {
      headers: {
        ...authHeader(),
      },
      data: { filePath }, // DELETE রিকোয়েস্টে body পাঠানোর জন্য
    });

    if (!response?.data?.message) {
      throw new Error(response?.data?.error || 'ফাইল ডিলিট ব্যর্থ হয়েছে।');
    }

    toast.success('ফাইল সফলভাবে ডিলিট হয়েছে!', { position: 'top-right' });
    return response.data.message;
  } catch (error) {
    let errorMsg = 'ফাইল ডিলিট ব্যর্থ: ';
    if (error.response) {
      errorMsg += error.response.data.error || `HTTP ${error.response.status} ত্রুটি`;
    } else if (error.request) {
      errorMsg += 'সার্ভার থেকে কোনো উত্তর পাওয়া যায়নি। নেটওয়ার্ক সমস্যা হতে পারে।';
    } else {
      errorMsg += error.message;
    }
    console.error('File delete error:', error);
    toast.error(errorMsg, { position: 'top-right' });
    throw new Error(errorMsg);
  }
};

export default fileDelete;